import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../colorVars';
import { Body4 } from '../../text/Text';
import style from './MessageBox.module.css';

type Props = {
  width: string;
};

export const MessageBox = observer(({ width }: Props) => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const validationStatus = tradePlanForm.validationStatus;

  return (
    <div className={style.outline} style={{ width }}>
      <Body4
        color={validationStatus.status === false ? colors.red : colors.green}
      >
        {validationStatus.message}
      </Body4>
    </div>
  );
});
